import React from "react";

import { getPreparationProgram } from "../../../../redux/directoryMaintenance/preparationProgramsReducer/actionsPreparationPrograms";

import GeneralSectionComponent from "../generalSectionComponent";
import PreparationProgramsModal from "./preparationProgramsModal/preparationProgramsModal";

import { PREPARATION_PROGRAMS } from "../../../../components/GeneralComponents/SearchTable/TablesColumns";

function PreparationPrograms() {
  return (
    <GeneralSectionComponent
      title="Программы подготовки судоводителей"
      dataFromStateSelector={(state) =>
        state.dictionaryReducer.allPreparationPrograms
      }
      getAction={getPreparationProgram}
      headerColumns={PREPARATION_PROGRAMS}
      ModalComponent={PreparationProgramsModal}
    />
  );
}

export default PreparationPrograms;
